import { reactive } from 'vue';

export const userPermission = reactive({
    permissionList: localStorage.getItem('userPermission') ? localStorage.getItem('userPermission').split(',') : [],
    getAllPermissionList() {
        return this.permissionList;
    },
    has(routeName) {
        return  this.permissionList.includes(routeName);
    },
})